import { Dispatch } from 'redux';
import createAction from './createAction';
import { ScopedSelectorCallback } from './types';

const createScopedAction =
    <S>(scopeSelector: ScopedSelectorCallback<S>) =>
    <T extends string, P>(actionType: T, payload: P) =>
    (dispatch: Dispatch, getState: () => S) => {
        const scope = scopeSelector(getState());
        return dispatch(createAction(actionType, payload, { scope }));
    };

export default createScopedAction;
